<template>
  <div>
    <span class="errorTotal">{{$t('stores.Records')}}:{{pageParams.total}}{{$t('pagination.Strip')}}</span>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('devices.esl.upload fail')" name="first">
        <el-table
          border
          :data="failTableData"
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column
            align="center"
            min-width="180"
            prop="tagIdentity"
            :label="$t('devices.esl.eslCode')"
          >
          </el-table-column>

          <el-table-column
            align="center"
            min-width="180"
            prop="order_type"
            :label="$t('devices.esl.taskType')"
          >
            <span slot-scope="scope" width="300">
              {{ scope.row.taskTypeName }}
            </span>
          </el-table-column>

          <el-table-column
            align="center"
            width="180"
            prop="update_result"
            :label="$t('devices.esl.status')"
            min-width="160"
          >
            <span
              slot-scope="scope"
              width="300"
              class="update-state"
              :class="{
                'state-success':
                  scope.row.updateResult == ESLE_STATE_ACTIVE ||
                  scope.row.updateResult == ESLE_STATE_UPDATING ||
                  scope.row.updateResult == ESLE_STATE_SUCCESS,
                'state-failed':
                  scope.row.updateResult == ESLE_STATE_FAILED ||
                  scope.row.updateResult == ESLE_STATE_UNACTIVE,
              }"
            >
              {{ scope.row.updateResultName }}
            </span>
          </el-table-column>

          <el-table-column
            align="center"
            min-width="180"
            prop="tid"
            :label="$t('devices.esl.taskID')"
          ></el-table-column>
          
          <el-table-column
            width="160"
            align="center"
            prop="createTime"
            :label="$t('devices.esl.updateTime')"
          >
            <span slot-scope="scope">
              {{ scope.row.createTime }}
            </span>
          </el-table-column>

          <el-table-column
            align="center"
            min-width="160"
            prop="updateMessage"
            :label="$t('devices.esl.message')"
          >
          </el-table-column>
          <el-table-column
            align="center"
            min-width="70"
            prop="Action"
            fixed="right"
            :label="$t('devices.Action')"
          >
            <span slot-scope="scope">
              <i
                class="el-icon-delete"
                style="font-weight: bold; cursor: pointer"
                @click="handleDelete(scope.row)"
              ></i>
            </span>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('devices.esl.offline esl')"
        name="second"
      ></el-tab-pane>
      <el-tab-pane
        :label="$t('devices.esl.low power')"
        name="third"
      ></el-tab-pane>
    </el-tabs>
    <el-table
      border
      :data="tableData"
      style="width: 100%"
      v-loading="tableLoading"
      v-if="activeName != 'first'"
    >
      <el-table-column
        align="center"
        min-width="180"
        prop="tagIdentity"
        :label="$t('devices.esl.eslCode')"
      >
      </el-table-column>
      <!-- 商品条码 -->
      <el-table-column
        align="center"
        min-width="180"
        prop="goodsCode"
        :label="$t('devices.esl.itemCode')"
      >
        <span slot-scope="scope" width="300">
          {{ scope.row.goodsCode }}
        </span>
      </el-table-column>
      <!-- 商品名称 -->
      <el-table-column
        align="center"
        min-width="180"
        prop="goodsName"
        :label="$t('devices.esl.name')"
      >
        <span slot-scope="scope" width="300">
          {{ scope.row.goodsName }}
        </span>
      </el-table-column>

      <el-table-column
        align="center"
        min-width="180"
        prop="order_type"
        :label="$t('devices.esl.Task State')"
        v-if="activeName == 'first'"
      >
        <span slot-scope="scope" width="300">
          {{ scope.row.taskTypeName }}
        </span>
      </el-table-column>

      <el-table-column
        align="center"
        min-width="180"
        prop="coorIp"
        :label="$t('devices.esl.aPIP')"
      >
        <span slot-scope="scope" width="300">
          {{ scope.row.coorIp }}
        </span>
      </el-table-column>
      <el-table-column
        width="160"
        align="center"
        prop="lastTaskStateName"
        :label="$t('taskManagerInfo.Task State')"
        v-if="activeName == 'third'"
      >
        <span slot-scope="scope">
          {{ scope.row.lastTaskStateName }}
        </span>
      </el-table-column>
      
      <el-table-column
        width="160"
        align="center"
        prop="tagTypeName"
        :label="$t('devices.esl.eSLType')"
      >
        <span slot-scope="scope">
          {{ scope.row.tagTypeName }}
        </span>
      </el-table-column>
      <el-table-column
        width="160"
        align="center"
        prop="createTime"
        :label="$t('devices.esl.updateTime')"
      >
        <span slot-scope="scope">
          {{ scope.row.createTime }}
        </span>
      </el-table-column>
      <el-table-column
        width="120"
        align="center"
        prop="electricity"
        :label="$t('devices.esl.electricity')"
        v-if="activeName == 'third'"
        fixed="right"
      >
        <span style="color:#f00;font-weight:bold;" slot-scope="scope">
          {{ scope.row.tagPower }}
        </span>
      </el-table-column>
    </el-table>
    <pagination :tableInfo="pageParams" @changePage="changePage" />
  </div>
</template>
<script>
import moment from "moment";
import { debounce } from "lodash";
import { getRecordList, getList, deleteTagRecord } from "@/libs/api/esls";
import { paginationEnum } from "@/libs/enum";
import pagination from "@/components/pagination";
import {
  ESLE_STATE_UNACTIVE,
  ESLE_STATE_ACTIVE,
  ESLE_STATE_UPDATING,
  ESLE_STATE_SUCCESS,
  ESLE_STATE_FAILED,
} from "@/libs/enum";
export default {
  components: {
    pagination,
  },
  props: {
    taskTypeList: {
      type: Array,
      require: true,
      default: () => [],
    },
    elsStateList: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  name: "ESLUpdateRecords",
  data() {
    return {
      ESLE_STATE_UNACTIVE,
      ESLE_STATE_ACTIVE,
      ESLE_STATE_UPDATING,
      ESLE_STATE_SUCCESS,
      ESLE_STATE_FAILED,
      paginationEnum,
      moment,
      pageParams: {
        current: 1,
        size: 10,
        total: 0,

        tid: "",
        updateResult: "",
        orderType: "",
        updateResult: "",
        createTimeStart: "",
        createTimeEnd: "",
        goodsMsg: "",
        updateMessage: "",
        tagRecordId: "",
        date: "",
        orders: [],
      },
      failTableData: [],
      tableData: [],
      tableLoading: false,
      oldActiveName: "first",
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);

      console.log(this.oldActiveName);
      // this.activeName =
      console.log(this.activeName);
      if (this.activeName == this.oldActiveName) {
        console.log("same");
      } else {
        this.tableData = [];
        this.failTableData = []
        this.pageParams.current = 1;
        this.pageParams.size = 10;
        this.oldActiveName = this.activeName;
        this.activeName == "first" && this.getRecordList();
        this.activeName == "second" && this.getOfflineList();
        this.activeName == "third" && this.getLowpowerList();
      }
    },
    // 表格排序
    // handleSort(column, prop, order) {
    //   console.log("表格排序", column, prop, order);
    //   let arr = [];
    //   if (column.order) {
    //     let str1 = column.order === "ascending" ? "asc" : "desc";
    //     str1 = str1 + ":" + column.prop;
    //     arr.push(str1);
    //   } else {
    //     arr = [];
    //   }

    //   this.pageParams.orders = arr;
    //   this.getRecordList();
    // },
    changePage() {
      console.log(this.activeName);
      this.activeName == "first" && this.getRecordList();
      this.activeName == "second" && this.getOfflineList();
      this.activeName == "third" && this.getLowpowerList();
    },
    handleDateChange(val) {
      if (val) {
        // this.pageParams.createTimeStart = moment(val[0]).format(
        //   "YYYY-MM-DD"
        // );
        // this.pageParams.createTimeEnd = moment(val[1]).format(
        //   "YYYY-MM-DD"
        // );
        let createTimeStart = val[0];
        let createTimeEnd = val[1];
        this.pageParams.createTimeStart = createTimeStart;
        this.pageParams.createTimeEnd = createTimeEnd;
        this.pageParams.date = val;
      } else {
        this.pageParams.createTimeStart = "";
        this.pageParams.createTimeEnd = "";
        this.pageParams.date = [];
      }
      this.getRecordList();
    },
    getRecordList: debounce(async function () {
      this.failTableData = [];
      const _this = this;
      const params = {
        isEffect:0,
        orderType: _this.pageParams.orderType,
        updateResult: 1004, // 更新失败的任务类型
        storeId: localStorage.getItem("storeId"),
        current: _this.pageParams.current,
        size: _this.pageParams.size,
      };
      _this.tableLoading = true;
      try {
        const { data } = await getRecordList(params);
        if (data.state === true) {
          let dataNew = data.data || {};
          _this.failTableData = dataNew.records || [];
          _this.failTableData.forEach((item) => {
            let goodsCode = JSON.parse(JSON.stringify(item.goodsMsg));
            if (item.goodsMsg && typeof goodsCode === "object") {
              goodsCode = goodsCode.join(",");
            }
            item.goodsCode = goodsCode;
          });
          _this.pageParams.total = dataNew.total || 0;
          _this.tableLoading = false;
        } else {
          this.$message.error(data.message);
          _this.tableLoading = false;
        }
      } catch (err) {
        const { message } = err;
        _this.$message.error(message);
        _this.tableLoading = false;
      }
    }, 1000),
    getLowpowerList() {
      this.tableData = [];
      const params = {
        storeId: localStorage.getItem("storeId"),
        storeQueryType: 2, // 仅当前门店
        isEffect: 0,
        current: this.pageParams.current,
        size: this.pageParams.size,
        tagPowerStart: 0,
        tagPowerEnd: 2.5,
      };
      getList(params).then((res) => {
        this.tableData = res.data.data.records;
        this.tableData.map(item => {
          // console.log(item.goodsName)
          // console.log(typeof item.goodsName)
          item.goodsCode =  item.goodsCode && item.goodsCode.join(',')
          item.goodsName =  item.goodsName && item.goodsName.join(',')
        })
        console.log(this.tableData)
        this.pageParams.total = res.data.data.total;
      });
    },
    getOfflineList() {
      const params = {
        storeId: localStorage.getItem("storeId"),
        storeQueryType: 2, // 仅当前门店
        isEffect: 0,
        current: this.pageParams.current,
        size: this.pageParams.size,
        connectivity: 1001, // 离线价签
      };
      getList(params).then((res) => {
        this.tableData = res.data.data.records;
        this.tableData.map(item => {
          item.goodsCode =  item.goodsCode && item.goodsCode.join(',')
          item.goodsName =  item.goodsName && item.goodsName.join(',')
        })
        this.pageParams.total = res.data.data.total;
      });
    },
    handleDelete(row) {
      console.log(row);

      const params = {
        tagRecordId: row.tagRecordId
      }
      this.$confirm(this.$t('devices.deleteTips'), "Tips", {
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText:this.$t('button.Cancel'),
        type: "warning",
      })
        .then(async () => {
            const { data } = await deleteTagRecord(params);
            if (data.code == 1) {
              this.$message.success(this.$t("devices.operationSuccess"));
              this.getRecordList();
            } else {
              this.$message.error(data.message);
            }
        })
        .catch((res) => {
          console.log(res)
        });
    },
  },
  created() {
    this.getRecordList();
    // this.getLowpowerList();
    // this.getOfflineList()
  },
};
</script>
<style lang="scss" scoped>
.communication-records_top {
  margin-bottom: 20px;
  .record-text {
    font-size: 16px;
    // color: #999999;
  }
}
.update-state {
  padding: 3px 18px;
  text-align: center;
  border-radius: 15px;
  display: inline-block;
}
.state-success {
  background: rgba(217, 250, 232, 1);
}
.state-failed {
  background: rgba(255, 224, 224, 1);
}
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.errorTotal{
  position: absolute;
  right: 20px;
  top: 70px;
}
</style>